import React, { useEffect, useState } from 'react';
import './Menu.css';
import Nav from "../components/Nav";
import { Footer } from '../components/footer';

import { Upperbox } from '../components/Upperbox';

import Scrolltop from '../components/Scrolltop';
import milkshakes from '../images/milk-shake.png'; 
import greenDot from '../images/green.png';  
import redDot from '../images/red.png'; 
    
import breakfast from "../images/breakfast.png";

import softdrinks from "../images/softdrinks.png";

import snacks from "../images/snacks.png";
import biryani from "../images/biryani.png";
import naan from "../images/naan.png";
import juices from "../images/juice.png";
import noodles from "../images/noodles.png";
import starters from "../images/starters.png";
import vegcurry from "../images/vegcurry.png";
import Tandoori from "../images/Tandoori.png";
const Menu = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [

    
    



    
      {
        category: 'Indian Breakfast',
        icon: <img src={breakfast} alt="Breakfast" style={{ width: '24px', height: '24px' }} />,
        items: [
          { service: 'Idly (3PCS)', price: '£4.49', description: 'Soft and fluffy steamed rice cakes served with chutney and sambar.', veg: true },
          { service: 'Ghee Podi Idly (3PCS)', price: '£4.99', description: 'Steamed idly coated with ghee and spiced podi powder.', veg: true },
          { service: 'Sambar Idly (3PCS)', price: '£4.99', description: 'Idly soaked in hot and flavorful sambar.', veg: true },
          { service: 'Vada (3PCS)', price: '£4.99', description: 'Crispy lentil fritters served with chutney and sambar.', veg: true },
          { service: 'Sambar Vada', price: '£5.49', description: 'Crispy lentil fritters dipped in delicious sambar.', veg: true },
          { service: 'Dosa', price: '£3.99', description: 'Crispy South Indian crepe made with fermented rice and lentil batter.', veg: true },
          { service: 'Masala Dosa', price: '£4.99', description: 'Crispy dosa stuffed with spiced mashed potatoes.', veg: true },
          { service: 'Onion Dosa', price: '£4.49', description: 'Crispy dosa topped with finely chopped onions.', veg: true },
          { service: 'SK Special Dosa', price: '£5.99', description: 'Customize your dosa with your choice of fillings.', veg: true },
          { service: 'Poori', price: '£4.99', description: 'Fluffy deep-fried Indian bread served with potato curry.', veg: true },
          { service: 'Dosa/Poori with Chicken Curry', price: '£7.99', description: 'Choice of dosa, or poori served with flavorful chicken curry.', veg: false }
        ]
      },

    
      {
        category: 'Starters',
        icon: <img src={starters} alt="Starters" style={{ width: '24px', height: '24px' }} />,
        items: [
          { service: 'Papad', price: '£0.99', description: 'Crispy and crunchy papad.', veg: true },
          { service: 'Masala Papad', price: '£1.99', description: 'Papad topped with fresh veggies and spices.', veg: true },
          { service: 'Fries', price: '£1.99', description: 'Classic French fries, crispy and golden.', veg: true },
          { service: 'Masala Fries', price: '£2.49', description: 'Fries tossed with Indian spices.', veg: true },
          { service: 'Veg Manchuria', price: '£6.49', description: 'Crispy vegetable dumplings in a tangy Manchurian sauce.', veg: true },
          { service: 'Onion Pakodi', price: '£4.99', description: 'Crispy onion fritters spiced with herbs.', veg: true },
          { service: 'Egg Manchuria', price: '£6.99', description: 'Boiled eggs tossed in a spicy Indo-Chinese sauce.', veg: false },
          { service: 'Chicken Manchuria', price: '£7.49', description: 'Crispy fried chicken tossed in a flavorful Manchurian sauce.', veg: false },
          { service: 'Chilli Chicken', price: '£7.49', description: 'Chicken stir-fried with spicy and tangy sauce.', veg: false },
          { service: 'Pepper Chicken', price: '£7.49', description: 'Chicken cooked with black pepper and aromatic spices.', veg: false },
          { service: 'Chicken Pakodi', price: '£7.49', description: 'Crispy bite-sized fried chicken pieces.', veg: false },
          { service: 'Chicken Liver Fry', price: '£4.99', description: 'Spiced and sautéed chicken liver.', veg: false },
          { service: 'Chilli Prawns', price: '£9.99', description: 'Juicy prawns stir-fried in spicy chilli sauce.', veg: false }
        ]
      },
    
    
      {
        category: 'Grills',
        icon: <img src={Tandoori} alt="Grills" style={{ width: '24px', height: '24px' }} />,
        items: [
          { service: 'Chicken Wings', price: '£4.99', description: 'Juicy and flavorful grilled chicken wings.', veg: false },
          { service: 'Chicken Tikka', price: '£6.99', description: 'Spiced and sautéed chicken liver.', veg: false },
          { service: 'Chicken Half Grill', price: '£7.99', description: 'Half portion of grilled chicken, seasoned with aromatic spices.', veg: false },
          { service: 'Chicken Full Grill', price: '£11.49', description: 'Whole grilled chicken, marinated with traditional spices.', veg: false },
          { service: 'Chicken Seekh Kebab', price: '£5.99', description: 'Minced chicken kebabs grilled on skewers.', veg: false },
          { service: 'Lamb Chops', price: '£9.50', description: 'Juicy and tender lamb chops grilled to perfection.', veg: false },
          { service: 'SK Special Platter', price: '£18.99', description: 'A grand assortment of our best-grilled meats.', veg: false }
        ]
      },
    
      {
        category: 'Curries',
        icon: <img src={vegcurry} alt="Curries" style={{ width: '24px', height: '24px' }} />,
        items: [
          { service: 'Lamb Curry', price: '£9.99', description: 'Tender lamb slow-cooked in a rich, spiced curry.', veg: false },
          { service: 'SK Chicken Curry', price: '£7.99', description: 'Traditional Indian-style chicken curry with a flavorful spice blend.', veg: false },
          { service: 'Butter Chicken', price: '£7.99', description: 'Creamy and mildly spiced tomato-based butter chicken.', veg: false },
          { service: 'Chicken Tikka Masala', price: '£7.99', description: 'Grilled chicken in a creamy, spiced tomato sauce.', veg: false }
        ]
      },
  
      {
        category: 'Indian Breads',
        icon: <img src={naan} alt="Breads" style={{ width: '24px', height: '24px' }} />,
        items: [
          { service: 'Chapathi', price: '£0.99', description: 'Soft whole wheat flatbread, light and healthy.', veg: true },
          { service: 'Paratha', price: '£1.49', description: 'Flaky, layered, and crispy Indian flatbread.', veg: true }
        ]
      },

     {
      category: 'Rice / Noodles',
      icon: <img src={noodles} alt="Rice / Noodles" style={{ width: '24px', height: '24px' }} />,
      items: [
        { service: 'Jeera Rice', price: '£3.99', description: 'Aromatic basmati rice tempered with cumin seeds.', veg: true },
        { service: 'Bagara Rice', price: '£3.99', description: 'Mildly spiced rice cooked with whole garam masala.', veg: true },
        { service: 'Veg Fried Rice / Noodles', price: '£6.49', description: 'Stir-fried rice or noodles with fresh vegetables and soy sauce.', veg: true },
        { service: 'Schezwan Veg Fried Rice / Noodles', price: '£6.99', description: 'Spicy Schezwan-style rice or noodles loaded with vegetables.', veg: true },
        { service: 'Schezwan Fried Chicken Rice / Noodles', price: '£7.99', description: 'Spicy Schezwan-style fried rice or noodles with chicken.', veg: false },
        { service: 'Fried Chicken Rice / Noodles', price: '£7.99', description: 'Classic fried rice or noodles tossed with chicken and spices.', veg: false },
        { service: 'Egg Rice / Noodles', price: '£6.99', description: 'Flavorful egg-fried rice or noodles with aromatic spices.', veg: false },
        { service: 'Prawns Fried Rice / Noodles', price: '£8.49', description: 'Juicy prawns tossed with fried rice or noodles.', veg: false },
        { service: 'Mixed Fried Rice / Noodles', price: '£9.99', description: 'A delicious combination of chicken, prawns, and egg stir-fried with rice or noodles.', veg: false },
        { service: 'Hyderabad Bandi Style Fried Rice / Noodles', price: '£7.99', description: 'Street-style Hyderabad fried rice with a signature spicy twist.', veg: true }
      ]
    },

    {
      category: 'Biryani',
      icon: <img src={biryani} alt="Biryani" style={{ width: '24px', height: '24px' }} />,
      items: [
        { service: 'Chicken Dum Biryani', price: '£7.99', description: 'Classic dum-cooked chicken biryani.', veg: false },
        { service: 'Chicken Dum Biryani JUMBO', price: '£17.99', description: 'Jumbo portion of classic dum-cooked chicken biryani.', veg: false },
        { service: 'Lamb Dum Biryani', price: '£8.99', description: 'Tender lamb cooked in aromatic biryani.', veg: false },
        { service: 'Lamb Dum Biryani JUMBO', price: '£19.99', description: 'Jumbo portion of lamb dum biryani.', veg: false },
        { service: 'Veg Paneer Biryani', price: '£7.49', description: 'Fragrant basmati rice with paneer and aromatic spices.', veg: true },
        { service: 'Special Chicken Biryani', price: '£8.49', description: 'Special chicken biryani with extra spices and flavors.', veg: false },
        { service: 'Prawn Biryani', price: '£9.99', description: 'Biryani with succulent prawns and flavorful spices.', veg: false }
      ]
    },

      
    {
      category: 'Indian Snacks',
      icon: <img src={snacks} alt="Indian Snacks" style={{ width: '24px', height: '24px' }} />,
      items: [
        { service: 'Mirchi Bhajji', price: '£3.49', description: 'Spicy green chilies battered and deep-fried.', veg: true },
        { service: 'Cut Mirchi Bhajji', price: '£3.99', description: 'Sliced mirchi bhajji with special seasoning.', veg: true },
        { service: 'Pav Bhaji', price: '£4.99', description: 'Spiced mashed vegetables served with buttered pav.', veg: true },
        { service: 'Pani Puri', price: '£3.99', description: 'Crispy puris filled with tangy water and spiced stuffing.', veg: true },
        { service: 'Samosa', price: '£3.49', description: 'Crispy pastry filled with spiced potatoes and peas.', veg: true },
        { service: 'Bhelpuri', price: '£3.49', description: 'Crunchy puffed rice snack with chutneys.', veg: true },
        { service: 'Vada Pav', price: '£3.49', description: 'Spicy potato fritter in a bun with chutneys.', veg: true },
        { service: 'Aloo Tikki Chaat', price: '£4.49', description: 'Crispy potato patties topped with chutneys and yogurt.', veg: true },
        { service: 'Papdi Chaat', price: '£4.49', description: 'Crispy papdi topped with yogurt, chutneys, and spices.', veg: true },
        { service: 'Spring Roll', price: '£3.49', description: 'Crispy vegetable-filled rolls.', veg: true }
      ]
    },
      
      
    {
      category: 'Milkshakes',
      icon: <img src={milkshakes} alt="Milkshakes" style={{ width: '24px', height: '24px' }} />,
      items: [
        { service: 'Vanilla Milkshake', price: '£4.49', description: 'Classic creamy vanilla milkshake.', veg: true },
        { service: 'Oreo Milkshake', price: '£4.49', description: 'Smooth and rich Oreo cookie milkshake.', veg: true },
        { service: 'Biscoff Milkshake', price: '£4.49', description: 'Deliciously spiced Biscoff cookie milkshake.', veg: true },
        { service: 'Strawberry Milkshake', price: '£4.49', description: 'Sweet and fruity strawberry milkshake.', veg: true },
        { service: 'Triple Chocolate Milkshake', price: '£4.49', description: 'A chocolate lover’s dream with triple chocolate.', veg: true },
        { service: 'Mango Lassi', price: '£4.99', description: 'Refreshing mango and yogurt drink.', veg: true }
      ]
    },
      
      


    {
      category: 'Fresh Juices',
      icon: <img src={juices} alt="Fresh Juices" style={{ width: '24px', height: '24px' }} />,
      items: [
        { service: 'ABC', price: '£4.49', description: 'A refreshing blend of apple, beetroot, and carrot.', veg: true },
        { service: 'Carrot Zing', price: '£4.49', description: 'Fresh carrot juice with a zesty twist of ginger.', veg: true },
        { service: 'Tropical Crush', price: '£4.49', description: 'A tropical mix of pineapple, mango, and orange.', veg: true },
        { service: 'Orange', price: '£4.49', description: 'Freshly squeezed orange juice.', veg: true },
        { service: 'Buttermilk', price: '£2.49', description: 'Traditional spiced Indian buttermilk.', veg: true }
      ]
    }
,
      
      


      // {
      //   category: 'Desserts',
      //   icon: <img src={sweets} alt="Desserts" style={{ width: '24px', height: '24px' }} />,
      //   items: [
      //     { service: 'Rice kheer', price: '£2.99', description: 'Traditional Indian rice pudding with cardamom and nuts.', veg: true },
      //     { service: 'Gulab jamun', price: '£2.99', description: 'Sweet and soft milk dumplings soaked in sugar syrup.', veg: true },
      //     { service: 'Gajar ka halwa', price: '£2.99', description: 'Warm carrot pudding with nuts and cardamom.', veg: true },
      //     { service: 'Double ka meeta', price: '£2.99', description: 'Hyderabadi-style bread pudding with saffron and dry fruits.', veg: true },
      //   ],
      // },
      
      
      
    
      
 
      
      
      {
        category: 'Soft Drinks',
        icon: <img src={softdrinks} alt="Soft Drinks" style={{ width: '24px', height: '24px' }} />,
        items: [
          { service: 'Irani Chai / Masala Chai', price: '£0.99', description: 'Traditional spiced tea with milk.', veg: true },
          { service: 'Water Bottle', price: '£0.99', description: 'Pure bottled drinking water.', veg: true },
          { service: 'Sparkling Water', price: '£0.99', description: 'Refreshing carbonated water.', veg: true },
          { service: 'Coke', price: '£1.49', description: 'Classic Coca-Cola soft drink.', veg: true },
          { service: 'Diet Coke', price: '£1.49', description: 'Low-calorie version of Coca-Cola.', veg: true },
          { service: 'Zero Coke', price: '£1.49', description: 'Sugar-free Coca-Cola.', veg: true },
          { service: 'Sprite', price: '£1.49', description: 'Lemon-lime flavored soda.', veg: true },
          { service: '7 Up', price: '£1.49', description: 'Crisp and refreshing lemon-lime drink.', veg: true },
          { service: 'Fanta', price: '£1.49', description: 'Fruity and fizzy orange-flavored soda.', veg: true },
          { service: 'Thums Up', price: '£1.99', description: 'Strong and fizzy Indian cola.', veg: true },
          { service: 'Lemonade', price: '£1.99', description: 'Refreshing lemon-flavored drink.', veg: true }
        ]
      }
      
      
      
    ];
    

  const [selectedCategory, setSelectedCategory] = useState(services[0]);

  return (
    <div className='pagee-bbackground'>
      <Upperbox />
      <Nav />

      <div className="price-container">
        <h5 className="price-title" data-aos="fade-down">Check Out What’s Cooking: Menu & Prices</h5>

        <div className="price-content">
          {/* Left Column */}
          <div className="price-sidebar">
            {services.map((serviceCategory, index) => (
              <button
                key={index}
                className={`category-button ${selectedCategory.category === serviceCategory.category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(serviceCategory)}
              >
                {serviceCategory.icon} {serviceCategory.category}
              </button>
            ))}
          </div>

          {/* Right Column */}
          <div className="price-details">
            <h6 className="category-title">{selectedCategory.icon} {selectedCategory.category}</h6>
            <table className="price-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {selectedCategory.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      <strong>{item.service} 
                        {/* Green dot for veg */}
                        {item.veg ? <img src={greenDot} alt="Veg" className="veg-dot" /> : 
                        <img src={redDot} alt="Non-Veg" className="non-veg-dot" />}
                      </strong>
                      <p className="service-description">{item.description}</p>
                    </td>
                    <td className="price">{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Scrolltop />
      <Footer />
    </div>
  );
};

export default Menu;
